import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Appbar from './Appbar';
import { styled, useTheme, alpha } from '@mui/material/styles';
import { Link, useLocation } from 'react-router-dom';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import FlatwareIcon from '@mui/icons-material/Flatware';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HotelIcon from '@mui/icons-material/Hotel';
import logo from "../../assets/order.png";
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/EventAvailable';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InventoryIcon from '@mui/icons-material/Inventory';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
}));

const StyledListItemButton = styled(ListItemButton)(({ theme, active }) => ({
    borderRadius: '12px',
    margin: '4px 8px',
    minHeight: 48,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        transform: 'translateX(4px)',
    },
    ...(active && {
        backgroundColor: alpha(theme.palette.primary.main, 0.12),
        color: theme.palette.primary.main,
        fontWeight: 600,
        '& .MuiListItemIcon-root': {
            color: theme.palette.primary.main,
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 4,
            height: '60%',
            backgroundColor: theme.palette.primary.main,
            borderRadius: '0 4px 4px 0',
        },
    }),
}));

const MenuLandingPage = ({ children }) => {
    const theme = useTheme();
    const location = useLocation();
    const [open, setOpen] = React.useState(true);
    const userType = localStorage.getItem("billing_app_type");

    let menu = userType == "Hotel and Restaurant" ? [
        { name: "Dashboard", icon: <DashboardIcon />, link: "/" },
        { name: "Table", icon: <TableRestaurantIcon />, link: "/table" },
        { name: "Room", icon: <HotelIcon />, link: "/room" },
        { name: "Guest", icon: <PersonIcon />, link: "/guest" },
        { name: "Reservation", icon: <CalendarTodayIcon />, link: "/reservation" },
        { name: "Food", icon: <FlatwareIcon />, link: "/food" },
        { name: "Order", icon: <AssignmentTurnedInIcon />, link: "/order" },
        { name: "Inventory", icon: <InventoryIcon />, link: "/inventory" },
        { name: "Expense", icon: <ReceiptIcon />, link: "/expense" },
        { name: "Report", icon: <AssignmentTurnedInIcon />, link: "/report" },
    ] : userType == "Hotel" ? [
        { name: "Dashboard", icon: <DashboardIcon />, link: "/" },
        { name: "Room", icon: <HotelIcon />, link: "/room" },
        { name: "Guest", icon: <PersonIcon />, link: "/guest" },
        { name: "Reservation", icon: <CalendarTodayIcon />, link: "/reservation" },
        { name: "Inventory", icon: <InventoryIcon />, link: "/inventory" },
        { name: "Expense", icon: <ReceiptIcon />, link: "/expense" },
        { name: "Report", icon: <AssignmentTurnedInIcon />, link: "/report" },
    ] : [
        { name: "Dashboard", icon: <DashboardIcon />, link: "/" },
        { name: "Table", icon: <TableRestaurantIcon />, link: "/table" },
        { name: "Food", icon: <FlatwareIcon />, link: "/food" },
        { name: "Order", icon: <AssignmentTurnedInIcon />, link: "/order" },
        { name: "Inventory", icon: <InventoryIcon />, link: "/inventory" },
        { name: "Expense", icon: <ReceiptIcon />, link: "/expense" },
        { name: "Report", icon: <AssignmentTurnedInIcon />, link: "/report" },
    ]

    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <Appbar drawerWidth={drawerWidth} open={open} setOpen={setOpen} />
                <Drawer
                    sx={{
                        width: open ? drawerWidth : 0,
                        flexShrink: 0,
                        transition: theme.transitions.create('width', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                            borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
                            boxShadow: '2px 0 8px rgba(0,0,0,0.04)',
                            transition: theme.transitions.create('width', {
                                easing: theme.transitions.easing.sharp,
                                duration: theme.transitions.duration.enteringScreen,
                            }),
                            overflowX: 'hidden',
                        },
                    }}
                    variant="persistent"
                    anchor="left"
                    open={open}
                >
                    <DrawerHeader>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
                            <img src={logo} alt='orderq' style={{ height: 40, transition: 'transform 0.3s' }} />
                        </Box>
                        <IconButton 
                            onClick={() => setOpen(!open)}
                            sx={{
                                transition: 'transform 0.3s',
                                '&:hover': {
                                    transform: 'rotate(180deg)',
                                }
                            }}
                        >
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </DrawerHeader>
                    <Divider />
                    <List sx={{ px: 1, py: 2 }}>
                        {menu?.map((item, index) => {
                            const isActive = location.pathname === item.link || 
                                (item.link === '/' && location.pathname === '/');
                            return (
                                <ListItem key={index} disablePadding>
                                    <Link 
                                        to={item.link} 
                                        style={{ 
                                            textDecoration: "none", 
                                            color: "inherit",
                                            width: '100%',
                                        }}
                                    >
                                        <StyledListItemButton active={isActive}>
                                            <ListItemIcon 
                                                sx={{ 
                                                    minWidth: 40,
                                                    color: isActive ? theme.palette.primary.main : 'inherit',
                                                    transition: 'color 0.3s',
                                                }}
                                            >
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText 
                                                primary={item.name}
                                                primaryTypographyProps={{
                                                    fontWeight: isActive ? 600 : 400,
                                                    fontSize: '0.95rem',
                                                }}
                                            />
                                        </StyledListItemButton>
                                    </Link>
                                </ListItem>
                            );
                        })}
                    </List>
                </Drawer>
                <Box component="main" sx={{ flexGrow: 1, width: "100%" }}>
                    {children}
                </Box>
            </Box>
        </>
    )
}

export default MenuLandingPage